import { render } from "./SettingsComunidades.vue?vue&type=template&id=a87be0e4"
import script from "./SettingsComunidades.vue?vue&type=script&lang=js"
export * from "./SettingsComunidades.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__